import { useEffect, useState } from "react";
import { getImageUrls, parseVerificationIds } from "../api/imageCache";

// Resolves a guest's comma separated verification IDs to displayable URLs.
// Keyed on the ID string itself, so editing one guest never refetches another's
// images, and the shared cache collapses repeats to a single request.
export default function useVerificationImages(verificationId) {
    const [urls, setUrls] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const ids = parseVerificationIds(verificationId);

        if (ids.length === 0) {
            setUrls([]);
            setLoading(false);
            return undefined;
        }

        let active = true;
        setLoading(true);

        getImageUrls(ids).then((resolved) => {
            if (!active) {
                return;
            }
            setUrls(resolved.filter(Boolean));
            setLoading(false);
        });

        return () => {
            active = false;
        };
    }, [verificationId]);

    return { urls, loading };
}
